import NiceModal, { useModal } from '@ebay/nice-modal-react';
import type { FieldValues } from 'react-hook-form';
import FiltersForm from '@/features/ChangeOrder/Summary/ChangeOrderMilestones/FilterBy/FiltersForm';
import type { ReactSelectOption } from '@/types/Constants';

type FiltersModalProps = {
  appliedFilters: FieldValues;
  displayFilters: FieldValues;
  submitterOptions: ReactSelectOption[];
  approverOptions: ReactSelectOption[];
  setDisplayFilters: React.Dispatch<React.SetStateAction<FieldValues>>;
  setAppliedFilters: React.Dispatch<React.SetStateAction<FieldValues>>;
};

export const FiltersModal = NiceModal.create<FiltersModalProps>(
  ({ submitterOptions, approverOptions, displayFilters, setDisplayFilters, setAppliedFilters }) => {
    const modal = useModal();

    if (!modal.visible) return null;

    return (
      <FiltersForm
        hide={modal.hide}
        submitterOptions={submitterOptions}
        approverOptions={approverOptions}
        displayFilters={displayFilters}
        handleAppliedFilters={setAppliedFilters}
        handleDisplayFilters={setDisplayFilters}
      />
    );
  }
);
